import { render, staticRenderFns } from "./ProductSegment.vue?vue&type=template&id=11de204e&scoped=true"
import script from "./ProductSegment.vue?vue&type=script&lang=ts"
export * from "./ProductSegment.vue?vue&type=script&lang=ts"
import style0 from "./ProductSegment.vue?vue&type=style&index=0&id=11de204e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11de204e",
  null
  
)

export default component.exports